module.exports = __webpack_public_path__ + "img/secondary_7x1_z18.7432baaa.svg";